import { useQuery } from '@tanstack/react-query';
import { PricingService } from '@spilca/order_ts/v1/order_web/pricing_web_pb_service';
import {
  ListPricingNamesRequest,
  ListPricingNamesResponse
} from '@spilca/order_ts/v1/order/model_pricing_pb';
import { QUERY_KEYS } from '@monorepo/helpers';
import { getGrpcPromise } from '@monorepo/grpc';
import {
  FILTER_PARAMS,
  DEAL_STATUS,
  RESOURCE_TYPE
} from '@monorepo/dictionary';
import { convertFiltersDict, convertToNameFilter } from './utils';

const useGetFilterNames = (filter: object | undefined) =>
  useQuery<ListPricingNamesResponse.AsObject, Error, any, any>({
    queryKey: [QUERY_KEYS.LIST_DEALS_FILTER_NAMES, filter],
    queryFn: (d): Promise<ListPricingNamesResponse.AsObject> => {
      const [, params] = d.queryKey;
      const getNames = getGrpcPromise(PricingService.ListPricingNames);
      const request = new ListPricingNamesRequest();
      const typeId = (Number(params[FILTER_PARAMS.typeId]) ||
        RESOURCE_TYPE.RESOURCES_SEEDS) as number;
      request.setBrandsList(
        convertToNameFilter(params[FILTER_PARAMS.brandId] || [], typeId)
      );
      request.setCategoriesList(
        convertToNameFilter(params[FILTER_PARAMS.cultureId] || [], typeId)
      );
      request.setProductsList(
        convertToNameFilter(params[FILTER_PARAMS.productId] || [], typeId)
      );
      request.setTypesList(
        convertToNameFilter(params[FILTER_PARAMS.typeId] || [], typeId)
      );

      request.setQuantityTypesList(
        convertToNameFilter(params[FILTER_PARAMS.quantityType] || [], typeId)
      );
      return getNames(request);
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 2*60*1000,
    select: (data) => ({
      [FILTER_PARAMS.cultureId]: convertFiltersDict(data.categoriesList),
      [FILTER_PARAMS.brandId]: convertFiltersDict(data.brandsList),
      [FILTER_PARAMS.productId]: convertFiltersDict(data.productsList),
      [FILTER_PARAMS.quantityType]: convertFiltersDict(data.quantityTypesList),
      // [FILTER_PARAMS.deliveryCondition]: convertFiltersDict(
      //   data.deliveryConditionsList
      // ),
      // [FILTER_PARAMS.paymentCondition]: convertFiltersDict(
      //   data.paymentConditionsList
      // ),
      [FILTER_PARAMS.typeId]: convertFiltersDict(data.typesList),
      [FILTER_PARAMS.status]: DEAL_STATUS
    })
  });

export default useGetFilterNames;
